(function() {
  function async(func) {
    setTimeout(function() {
      func();
    }, 256);
  }

  async(function() {
    // 初期化処理
    // console.log("initialize gi_pointify");
    const giShopifyObject = giPointifyFunctions.getGiShopifyObject();
    const giPointifyObject = giPointifyFunctions.getGiPointifyObject();
    // console.log({giShopifyObject, giPointifyObject});

    const giPointifyView = new GiPointifyView({giShopifyObject, giPointifyObject});
    window.giPointify = {
      giPointifyFunctions: giPointifyFunctions,
      giShopifyObject: giShopifyObject,
      giPointifyObject: giPointifyObject,
      giPointifyView: giPointifyView,
    };
    giPointifyView.setViews();
  });
})();

class GiPointifyView {
  constructor({giShopifyObject, giPointifyObject}) {
    this.giShopifyObject = giShopifyObject
    this.giPointifyObject = giPointifyObject
    this.threshold = 1;
    this.giServerApi = new GiServerApi({giShopifyObject});
    this.giShopifyApi = new GiShopifyApi();

    this.debug_dom_params = this.giPointifyObject.store_dom_params_hash.debug_dom_params;
    this.console_log = this.debug_dom_params ? console.log : () => {};
    this.console_error = this.debug_dom_params ? console.error : () => {};

    this._selectorsInputProductVariantId = 'form[action="/cart/add"] input[name^=id]:checked, select[name^=id], input[name=id], hidden[name^=id]';
    this._selectorsSubmitCreateCheckout = 'button[type="submit"][form="cart"]';
    // this._selectorsFormCreateCheckout = "form[action='/cart']";

    this._selectorsInputGiPointifyUsePoint = "input#__gi-pointify-use-point";

    this._idGiPointifyAccountViewContainer = "gi-pointify-account-info-container";
    this._idGiPointifyInputPointContainer = "gi-pointify-input-point-container";
    this._idGiPointifyInputUsePoint = "gi-pointify-input-use-point";
    this._idGiPointifyButtonSetUsePoint = "gi-pointify-button-set-use-point";
    this._idGiPointifyExternalOrderSummariesContainer = "gi-pointify-external-order-summaries-container";

    this._classGiPointifyContainer = "gi-pointify-container";
    this._classGiPointifyContainerDiscountCodeDisplay = "gi-pointify-container-discount-code-display";
    this._classGiPointifyContainerTag = "gi-pointify-container-tag";
    this._classGiPointifyContainerDisplayOnGotCustomer = "gi-pointify-container-display-on-got-customer"; // customerを取得できた場合に表示させるコンテナに付与するクラス
    this._classGiPointifyButtonTagClose = "gi-pointify-button-tag-close";
    this._classGiPointifyContainerExtendCartForm = "gi-pointify-container-extend-cart-form";
    this._classGiPointifyExternalOrderSummariesContainer = "gi-pointify-container-external-order-summaries";
    this._classGiPointifyContainerDisplayOnGotExternalOrderSummaries = "gi-pointify-container-display-on-got-external-orders"; // externalOrdersを取得できた場合に表示させるコンテナに付与するクラス

    // ポイント付加情報
    this._classGiPointifyPointInfosContainer = "gi-pointify-container-point-infos";
    this._classGiPointifyContainerDisplayOnGotPointInfos = "gi-pointify-container-display-on-got-point-infos";
    this._classGiPointifyPointInfosForCartContainer = "gi-pointify-container-point-infos-for-cart-%s";

    this._classGiPointifyContainerInputHiddenDiscountCode = "gi-pointify-container-input-use-discount-code";
    this._classGiPointifyInputHiddenDiscountCode = "gi-pointify-input-use-discount-code";

    this._classGiPointifyAvailablePoint = 'gi-pointify-available-point';
    this._classGiPointifyExpiredAt = 'gi-pointify-expired-at';
    this._classGiPointifyNormalAvailablePoint = 'gi-pointify-normal-available-point';
    this._classGiPointifyNormalExpiredAt = 'gi-pointify-normal-expired-at';
    this._classGiPointifyLimitedAvailablePoint = 'gi-pointify-limited-available-point';
    this._classGiPointifyLimitedExpiredAt = 'gi-pointify-limited-expired-at';
    this._classGiPointifyLimitedList = 'gi-pointify-limited-list-label';
    this._classGiPointifyLimitedList = 'gi-pointify-limited-list';
    this._classGiPointifyCurrentRankName = 'gi-pointify-current-rank-name';
    this._classGiPointifyNextRankDiff = 'gi-pointify-next-rank-diff';
    this._classGiPointifyCanGetPoints = 'gi-pointify-can-get-points';

    this.getCustomerPromise = null;
    this.getExternalOrderSummariessPromise = null;
    this.customer = null;
    this.externalOrderSummaries = null;

    this.customerDiscountCode = null
  }

  getCustomer() {
    if(this.getCustomerPromise == null) {
      this.getCustomerPromise = new Promise((resolve) => {
        if(!this.giShopifyObject.customer.id) {
          // customer_id なし
          resolve(false)
        } else if(this.customer) {
          // 取得済
          resolve(true)
        } else {
          this.giServerApi.getCustomer({
            customerId: this.giShopifyObject.customer.id
          }).then(result => {
            this.console_log({method: "getCustomer", result});
            this.customer = result;
            resolve(true);
          });
        }
      }).then(() => {
        return this.customer;
      })
    }

    return this.getCustomerPromise;
  }

  getExternalOrderSummaries() {
    if(this.getExternalOrderSummariessPromise == null) {
      this.getExternalOrderSummariessPromise = new Promise((resolve) => {
        resolve(this.getCustomer());
      }).then((customer) => {
        return new Promise((resolve) => {
          if (!customer) {
            resolve(false);
          } else if(this.externalOrderSumaries) {
            resolve(true);
          } else {
            this.giServerApi.getExternalOrderSummaries().then(result => {
              this.console_log({method: "getExternalOrderSummaries", result});
              this.externalOrderSumaries = result;
              resolve(true);
            });
          }
        });
      }).then(() => {
        return this.externalOrderSumaries;
      })
    }
    return this.getExternalOrderSummariessPromise;
  }

  getPointInfo(products=null) {
    let product_id = (products) ? products['product_id'] : this.giShopifyObject.product.id;
    let price = (products) ? products['price'] : this.giShopifyObject.product.price;
    let quantity = (products) ? products['quantity'] : 1;
    let fetch_type = (products) ? 'cart' : 'product';
    if(this.getPointInfoPromise == null) {
      this.getPointInfoPromise = new Promise((resolve) => {
        // if(!this.giShopifyObject.product.id) {
        if(!product_id) {
          // customer_id なし
          resolve(false)
        } else if(this.pointInfo) {
          // 取得済
          resolve(true)
        } else {
          this.giServerApi.getPointInfo({
            // productId: this.giShopifyObject.product.id,
            productId: product_id,
            price: price,
            quantity: quantity,
            fetchType: fetch_type
          }).then(result => {
            this.console_log({method: "getPointInfo", result});
            this.pointInfo = result;
            resolve(true);
          });
        }
      }).then(() => {
        return this.pointInfo;
      })
    }
    return this.getPointInfoPromise;
  }

  setViews() {
    const promise = new Promise((resolve) => {
      this.setupCartView()
      this.setupProductVariantPointView();
      this.setPointInfoView();
      this.setAccountInfoView();
      resolve(true);
    }).then(() => {
      return this.getCustomer();
    }).then((customer) => {
      // this.setViewValues({customer})
      return customer;
    })
    return promise;
  }

  getCustomerAndUpdateView() {
    // customerの情報を取得した後に各viewに必要な値を設定する
    const promise = new Promise((resolve) => {
      resolve(this.getCustomer())
    }).then((customer) => {

      // 利用可能point系を表示
      let elements = null;
      const htmlAvailablePoint = (customer ? `${customer.available_point} ポイント` : "");
      elements = document.querySelectorAll(`.${this._classGiPointifyAvailablePoint}`);
      elements.forEach((element) => {
        element.innerHTML = htmlAvailablePoint
      });

      // inputのmaxを設定
      // console.log("set max")
      const attributePointMax = (customer ? customer.available_point : 0);
      elements = document.querySelectorAll(`input.${this._idGiPointifyInputUsePoint}`);
      elements.forEach((element) => {
        element.setAttribute("max", attributePointMax);
      });

      // 有効期限
      let htmlExpiredAt = "-";
      if (customer && customer.expired_at) {
        const date = new Date(customer.expired_at);
        htmlExpiredAt = `${date.toLocaleString('ja-JP')}`;
      }
      elements = document.querySelectorAll(`.${this._classGiPointifyExpiredAt}`);
      elements.forEach((element) => {
        element.innerHTML = htmlExpiredAt
      });

      // 通常：ポイント
      const htmlNormalAvailablePoint = (customer ? `${customer.available_point_detail.normal.available_point} ポイント` : "");
      elements = document.querySelectorAll(`.${this._classGiPointifyNormalAvailablePoint}`);
      elements.forEach((element) => {
        element.innerHTML = htmlNormalAvailablePoint
      });
      // 通常：有効期限
      let htmlNormalExpiredAt = "-";
      if (customer && customer.available_point_detail.normal.expired_at) {
        const date = new Date(customer.available_point_detail.normal.expired_at);
        htmlNormalExpiredAt = `${date.toLocaleString('ja-JP')}`;
      }
      elements = document.querySelectorAll(`.${this._classGiPointifyNormalExpiredAt}`);
      elements.forEach((element) => {
        element.innerHTML = htmlNormalExpiredAt
      });
      // 期間限定：ポイント
      const htmlLimitedAvailablePoint = (customer ? `${customer.available_point_detail.limited.available_point} ポイント` : "");
      elements = document.querySelectorAll(`.${this._classGiPointifyLimitedAvailablePoint}`);
      elements.forEach((element) => {
        element.innerHTML = htmlLimitedAvailablePoint
      });
      // 期間限定：有効期限
      let htmlLimitedExpiredAt = "-";
      if (customer && customer.available_point_detail.limited.expired_at) {
        const date = new Date(customer.available_point_detail.limited.expired_at);
        htmlLimitedExpiredAt = `${date.toLocaleString('ja-JP')}`;
      }
      elements = document.querySelectorAll(`.${this._classGiPointifyLimitedExpiredAt}`);
      elements.forEach((element) => {
        element.innerHTML = htmlLimitedExpiredAt
      });
      // 期間限定：一行づつ
      if (customer && customer.available_point_detail.limited.list.length > 0) {
        let button = document.querySelector(`.gi-pointify-grid-container-3-more-button`);
        elements = document.querySelector(`.gi-pointify-grid-container-3`);
        customer.available_point_detail.limited.list.forEach((list, index) => {
          if(index > 1){
            elements = document.querySelector(`.gi-pointify-grid-container-3-more`);
            button.style.display = 'block';
          }
          let elem = document.createElement("div");
          elem.setAttribute('class', 'gi-pointify-grid-item gi-pl05');
          elem.innerHTML = '期間限定';
          elements.appendChild(elem)

          elem = document.createElement("div");
          elem.setAttribute('class', 'gi-pointify-grid-item');
          elem.innerHTML = `${list['available_point']} ポイント`;
          elements.appendChild(elem)

          elem = document.createElement("div");
          elem.setAttribute('class', 'gi-pointify-grid-item');
          const date = new Date(list['expired_at']);
          elem.innerHTML = date.toLocaleString('ja-JP');
          elements.appendChild(elem)
        });
        button.addEventListener('click', (event) => {
          button.classList.toggle('on-click');
          let elem = document.querySelector(`.gi-pointify-grid-container-3-more`);
          elem.classList.toggle('gi-display-grid-important');
        });
      }

      // rank名を表示
      let htmlCurrentRankName = "-";
      if (customer && customer.rank_name) {
        htmlCurrentRankName = `${customer.rank_name}`;
      }
      elements = document.querySelectorAll(`.${this._classGiPointifyCurrentRankName}`);
      elements.forEach((element) => {
        element.innerHTML = htmlCurrentRankName
      });

      // 次のrankまでを表示
      let htmlNextRankDiff = "-";
      if (customer && customer.rank_diff_spent_and_condition_min_of_next_rank) {
        htmlNextRankDiff = `${Math.round(customer.rank_diff_spent_and_condition_min_of_next_rank)}円`;
      }
      elements = document.querySelectorAll(`.${this._classGiPointifyNextRankDiff}`);
      elements.forEach((element) => {
        element.innerHTML = htmlNextRankDiff
      });

      // 表示するorしないを変更
      elements = document.querySelectorAll(`.${this._classGiPointifyContainerDisplayOnGotCustomer}`);
      elements.forEach((element) => {
        if(customer) {
          element.removeAttribute("hidden");
        } else {
          element.setAttribute("hidden", true);
        }
      });

      return customer;
    })
    return promise;
  }

  getExternalOrderSummariesAndUpdateView() {
    // externalOrdersの情報を取得した後に各viewに必要な値を設定する
    const promise = new Promise((resolve) => {
      resolve(this.getExternalOrderSummaries());
    }).then((externalOrderSummaries) => {
      this.console_log({externalOrderSummaries});

      // tableを表示
      let elements = null;
      if (externalOrderSummaries && 0 < externalOrderSummaries.length) {
        const html = this.createExternalOrdersTable(externalOrderSummaries);
        elements = document.querySelectorAll(`.${this._classGiPointifyExternalOrderSummariesContainer}`);
        elements.forEach((element) => {
          element.innerHTML = html
        });
      }

      // 表示するorしないを変更
      elements = document.querySelectorAll(`.${this._classGiPointifyContainerDisplayOnGotExternalOrderSummaries}`);
      elements.forEach((element) => {
        if(externalOrderSummaries && 0 < externalOrderSummaries.length) {
          element.removeAttribute("hidden");
        } else {
          element.setAttribute("hidden", true);
        }
      });

      return externalOrderSummaries;
    })
    return promise;
  }
  getPointInfoAndUpdateViewForCart(params) {
    const promise = new Promise((resolve) => {
      resolve(this.getPointInfo(params));
    }).then((pointInfo) => {
      this.console_log({pointInfo});
      let elements = null;
      if (pointInfo && 0 < Object.keys(pointInfo).length) {
        for(let key in pointInfo){
          const html = this.createPointInfosHtmlForCart(pointInfo[key]);
          elements = document.querySelectorAll(`.${this._classGiPointifyPointInfosForCartContainer.replace('%s',pointInfo[key]['product_id'])}`);
          elements.forEach((element) => {
            element.innerHTML = html
          });
        }
      }
      // 表示するorしないを変更
      for(let key in pointInfo){
        elements = document.querySelectorAll(`.${this._classGiPointifyPointInfosForCartContainer.replace('%s',pointInfo[key]['product_id'])}`);
        elements.forEach((element) => {
          if(pointInfo[key] && 0 < Object.keys(pointInfo[key]).length) {
            element.removeAttribute("hidden");
          } else {
            element.setAttribute("hidden", true);
          }
        });
      }
      return pointInfo;
    })
    return promise;
  }

  getPointInfoAndUpdateView(rounded_point) {
    const promise = new Promise((resolve) => {
      resolve(this.getPointInfo());
    }).then((_pointInfo) => {
      let elements = null;
      let pointInfo = null
      if (_pointInfo && 0 < Object.keys(_pointInfo).length) {
        pointInfo = Object.entries(_pointInfo)[0][1];
        const html = this.createPointInfosHtml(pointInfo);
        elements = document.querySelectorAll(`.${this._classGiPointifyPointInfosContainer}`);
        elements.forEach((element) => {
          element.innerHTML = html
        });
      }
      // 表示するorしないを変更
      elements = document.querySelectorAll(`.${this._classGiPointifyContainerDisplayOnGotPointInfos}`);
      elements.forEach((element) => {
        if(pointInfo && pointInfo['is_increase']) {
          element.removeAttribute("hidden");
          let canGetPointsDiv = document.querySelector(`.${this._classGiPointifyCanGetPoints}`);
          let increase_point = Math.round(rounded_point * (pointInfo['rate']/100))
          let newTextNode = document.createTextNode(`${increase_point} ポイント還元`);
          canGetPointsDiv.replaceChild(newTextNode, canGetPointsDiv.lastChild);
        } else {
          element.setAttribute("hidden", true);
        }
      });
      return pointInfo;
    })
    return promise;
  }

  getCustomerDiscountCodeAndUpdateView() {
    // customerDiscountCodeの情報を取得した後に各viewに必要な値を設定する
    return this.giShopifyApi.getCart().then((cart) => {
      // console.log("got cart", {cart});
      // discount_code 作成
      return this.giServerApi.getCustomerDiscountCode({cart});
    }).then(({customerDiscountCode, messages}) => {
      this.updateViewByCustomerDiscountCode({customerDiscountCode, messages});
      return {customerDiscountCode, messages};
    })
  }
  updateViewByCustomerDiscountCode({customerDiscountCode, messages}) {
    // customerDiscountCodeから各viewに必要な値を設定する
    this.console_log("updateViewByCustomerDiscountCode", {customerDiscountCode, messages});
    this.customerDiscountCode = customerDiscountCode;
    let isEnableDiscountCode = false;
    let temporarilyUsePoint = 0;
    let temporarilyDiscountAmount = 0;
    if (this.customerDiscountCode) {
      temporarilyDiscountAmount = parseFloat(this.customerDiscountCode.temporarily_discount_amount);
      temporarilyUsePoint = this.customerDiscountCode.temporarily_use_point;
      if (0 != temporarilyDiscountAmount || 0 != temporarilyUsePoint) {
        isEnableDiscountCode = true;
      }
    }
    if (isEnableDiscountCode) {
      // inputに設定
      this.createInputDiscountCode(this.customerDiscountCode.code);
      // tagを表示
      const displayDiscountCodeElements = document.querySelectorAll(`.${this._classGiPointifyContainerDiscountCodeDisplay}`);
      displayDiscountCodeElements.forEach((element, i) => {
        element.innerHTML = "";
        element.append(this.createElementDiscountCodeTag(`${temporarilyDiscountAmount} 円値引`, this.customerDiscountCode.code));
      });

    } else {
      // inputを削除
      this.deleteInputDiscountCode();
      // tagを非表示
      const displayDiscountCodeElements = document.querySelectorAll(`.${this._classGiPointifyContainerDiscountCodeDisplay}`);
      displayDiscountCodeElements.forEach((element, i) => {
        element.innerHTML = (messages && messages.errors) ? messages.errors : "";
      });
    }

    // point入力欄設定
    const inputPointElement = document.querySelector(`#${this._idGiPointifyInputUsePoint}`);
    inputPointElement.value = (0 < temporarilyUsePoint) ? temporarilyUsePoint : "";
  }

  setupCartView() {
    this.initContainerExtendCartForm();
    this.initContainerViewCartPoint();
    this.updateViewProhibitUseContainerViewCartPoint();
    this.initGivenPointViewForCart();

    if (true) {
      // 表示箇所変更イベント
      const parentElement = document.querySelector('[data-cart-form-wrapper]');
      if (parentElement) {
        const callback = (mutationsList, observer) => {
          this.console_log("observed_cart_form_wrapper", mutationsList, observer);

          if (mutationsList.length == 1) {
            const container = document.querySelector(`#${this._idGiPointifyInputPointContainer}`);
            if (container == mutationsList[0].target) {
              // 更新対象と変更された要素が一致している場合はスキップする
              return false;
            }
          }
          this.initContainerViewCartPoint();
          this.updateViewProhibitUseContainerViewCartPoint();
        };
        const observer = new MutationObserver(callback);
        const config = {attributes: true, childList: true, subtree: true};
        observer.observe(parentElement, config);
        // this.console_log(parentElement);
      }
    }
  }

  initGivenPointViewForCart() {
    if (!location.pathname.indexOf('/cart')){
      //console.log(this.giShopifyObject.cart.items);
      // console.log(this.giShopifyObject);
      let params = {'product_id':'', 'price':'', 'quantity':''}
      let separator = ''
      this.giShopifyObject.cart.items.forEach((object, i) => {
        separator = i > 0 ? ',' : '';
        params['product_id'] += separator + object['product_id']
        params['price'] += separator + object['final_price']
        params['quantity'] += separator + object['quantity']
      });
      this.getPointInfoAndUpdateViewForCart(params);
    }
  }

  updateViewProhibitUseContainerViewCartPoint() {
    this.console_log("updateViewProhibitUseContainerViewCartPoint");

    // 特定要素が存在する場合にポイント使用欄を非表示とする
    const targetElementSelector = this.giPointifyObject.store_dom_params_hash.prohibit_use_of_cart_point_if_target_element;
    if (!targetElementSelector) {
      return false;
    }

    const targetElement = document.querySelector(targetElementSelector);
    const containerElement = document.querySelector(`#${this._idGiPointifyInputPointContainer}`);
    if (containerElement) {
      if (targetElement) {
        containerElement.style.display = "none";
      } else {
        containerElement.style.display = "block";
      }
    }
  }

  setupProductVariantPointView() {
    // productページのsetup
    this.initContainerViewProductVariantPoint();
  }

  updateProductVariantPointView() {

  }

  setEventListenerOnChangeProductVariantId(func) {
    const element = document.querySelector(this._selectorsInputProductVariantId);
    if (element) {
      element.addEventListener('change', (event) => {
        // this.console_log("onChange", {event})
        func && func(event)
      })
    }
  }
  getCurrentProductVariantId() {
    const element = document.querySelector(this._selectorsInputProductVariantId);
    return element.value;
  }

  createPointValue() {

  }

  setPointInfoView() {
    if (!this.giShopifyObject.customer.id || !this.giShopifyObject.product || this.threshold < 0) {
      // 以下の場合は何もしない
      // productページではない場合
      // ログインしていない
      // 閾値が0未満の場合は何もしない
      return false;
    }

  }


  setAccountInfoView() {
    // アカウントページに自身のポイントを表示する
    this.initContainerViewAccountInfo();
    // アカウントページに外部注文履歴を表示する
    this.initContainerViewExternalOrderSummaries();
  }

  initContainerViewAccountInfo() {
    const selectorViewAccountInfoContainer = this.giPointifyObject.store_dom_params_hash.selector_view_account_info_container;
    const positionViewAccountInfoContainer = this.giPointifyObject.store_dom_params_hash.position_view_account_info_container;
    if (!selectorViewAccountInfoContainer) {
      // account-infoに表示なし
      this.console_log("initContainerViewAccountInfo", "not setting selectorViewAccountInfoContainer");
      return false
    }
    const targetElement = document.querySelector(selectorViewAccountInfoContainer);
    if (!targetElement) {
      // 対象のelementなし
      this.console_error("initContainerViewAccountInfo", "not found targetElement(account-info injection)", selectorViewAccountInfoContainer);
      return false;
    }

    let element = document.querySelector(`#${this._idGiPointifyAccountViewContainer}`);

    if(element) {
      // 既に作成されている場合
      this.console_log("initContainerViewAccountInfo", "alread init element", element);
      return false;
    }

    this.console_log("initContainerViewAccountInfo", "create div", element);
    // まだ未設置の場合、作成して設置
    element = document.createElement("div");
    element.id = this._idGiPointifyAccountViewContainer;
    element.className = this._classGiPointifyContainerDisplayOnGotCustomer;
    element.setAttribute("hidden", true);

    const displayHeaderTitle = "ポイント情報";
    const displayLabelAvailablePoint = "保有ポイント";
    const displayLabelExpiredAt = "有効期限";
    const displayLabelNormalAvailablePoint = "通常";
    // const displayLabelNormalExpiredAt = "有効期限";
    const displayLabelLimitedAvailablePoint = "期間限定";
    //const displayLabelLimitedExpiredAt = "有効期限";
    const displayLabelCurrentRank = "現在のランク";
    const displayLabelNextRankDiff = "次のランクまであと";
    let html = "";
    html += `<div class="gi-pointify-grid-container">`;
    // html += `  <div class="gi-pointify-grid-item-header strong">${displayHeaderTitle}</div>`;
    html += `  <div class="gi-pointify-grid-item gi-font-size125">${displayLabelAvailablePoint}</div>`;
    html += `  <div class="gi-pointify-grid-item gi-font-size125"><span class="${this._classGiPointifyAvailablePoint}"></span></div>`;
    // html += `  <div class="gi-pointify-grid-item">${displayLabelExpiredAt}</div>`;
    // html += `  <div class="gi-pointify-grid-item"><span class="${this._classGiPointifyExpiredAt}"></span></div>`;
    html += `</div>`;

    html += `<div class="gi-pointify-grid-container-3">`;
    html += `  <div class="gi-pointify-grid-item gi-pl05">種別</div>`;
    html += `  <div class="gi-pointify-grid-item">ポイント</div>`;
    html += `  <div class="gi-pointify-grid-item">有効期限</div>`;
    html += `  <div class="gi-pointify-grid-item gi-pl05">${displayLabelNormalAvailablePoint}</div>`;
    html += `  <div class="gi-pointify-grid-item"><span class="${this._classGiPointifyNormalAvailablePoint}"></span></div>`;
    html += `  <div class="gi-pointify-grid-item"><span class="${this._classGiPointifyNormalExpiredAt}"></span></div>`;
    html += `</div>`;

    html += `<div class="gi-pointify-grid-container-3-more"></div>`;
    html += `<button class="gi-pointify-grid-container-3-more-button"></button>`;

    html += `<div class="gi-pointify-grid-container">`;
    html += `  <div class="gi-pointify-grid-item">${displayLabelCurrentRank}</div>`;
    html += `  <div class="gi-pointify-grid-item"><span class="${this._classGiPointifyCurrentRankName}"></span></div>`;
    html += `  <div class="gi-pointify-grid-item">${displayLabelNextRankDiff}</div>`;
    html += `  <div class="gi-pointify-grid-item"><span class="${this._classGiPointifyNextRankDiff}"></span></div>`;
    html += `</div>`;
    element.innerHTML = html;
    if (positionViewAccountInfoContainer === "before") {
      targetElement.before(element);
    } else {
      targetElement.after(element);
    }
    this.getCustomerAndUpdateView();
  }

  createElementHtmlDivAvailablePoint() {
    const displayLabelAvailablePoint = "保有ポイント";
    let html = "";
    html += `<div class="gi-pointify-flex">`;
    html += `  <div class="gi-pointify-label">${displayLabelAvailablePoint}</div>`;
    html += `  <div class="gi-pointify-value"><span class="${this._classGiPointifyAvailablePoint}"></span></div>`;
    html += `</div>`;
    return html;
  }

  initContainerViewCartPoint() {
    // cart-pageに使用pointを入力するformを作成する
    const selectorViewCartPointContainer = this.giPointifyObject.store_dom_params_hash.selector_view_cart_point_container;
    const positionViewCartPointContainer = this.giPointifyObject.store_dom_params_hash.position_view_cart_point_container;
    if (!selectorViewCartPointContainer) {
      // cart-pageに表示なし
      this.console_log("initContainerViewCartPoint", "not setting selectorViewCartPointContainer");
      return false
    }
    const targetElement = document.querySelector(selectorViewCartPointContainer);
    if (!targetElement) {
      // 対象のelementなし
      this.console_error("initContainerViewCartPoint", "not found targetElement(cart-point injection)", selectorViewCartPointContainer);
      return false;
    }

    let element = document.querySelector(`#${this._idGiPointifyInputPointContainer}`);

    if(element) {
      // 既に作成されている場合
      this.console_log("initContainerViewCartPoint", "alread init element", element);
      return false;
    }

    this.console_log("initContainerViewCartPoint", "create div", element);
    // まだ未設置の場合、作成して設置
    element = document.createElement("div");
    element.id = this._idGiPointifyInputPointContainer;
    element.className = `${this._classGiPointifyContainer} ${this._classGiPointifyContainerDisplayOnGotCustomer}`;
    element.setAttribute("hidden", true);
    let html = "";
    html += `<div class="gi-pointify-flex-column">`;
    html += this.createElementHtmlDivAvailablePoint();
    html += `  <form method="post">`;
    html += `    <div class="gi-pointify-flex">`;
    html += `      <div class="gi-pointify-input-wrapper">`;
    html += `        <input type="number" id="${this._idGiPointifyInputUsePoint}" name="use_point" placeholder="使用ポイント" min="0" `;
    html += `          value="" >`;
    html += `      </div>`;
    html += `      <div class="gi-pointify-input-wrapper">`;
    html += `        <button type="submit" value="commit" id="${this._idGiPointifyButtonSetUsePoint}" class="btn btn--secondary">`
    html += `          ポイントを使用する`
    html += `        </button>`
    html += `      </div>`;
    html += `    </div>`;
    html += `  </form>`;
    html += `  <div class="${this._classGiPointifyContainerDiscountCodeDisplay}"></div>`;
    html += `</div>`;
    element.innerHTML = html;
    if (positionViewCartPointContainer === "before") {
      targetElement.before(element);
    } else {
      targetElement.after(element);
    }

    // ポイント使用ボタン
    const button = document.querySelector(`#${this._idGiPointifyButtonSetUsePoint}`);
    button.addEventListener("click", (event) => {
      // console.log("on click use point")
      event.preventDefault();

      const input = document.querySelector(`#${this._idGiPointifyInputUsePoint}`)
      const usePoint = input.value;
      if (usePoint <= 0 && this.customerDiscountCode.temporarily_use_point <= 0) {
        // 既に発行済のdiscount_codeも0の場合は何もしない
        input.value = null;
        return false;
      }

      button.setAttribute("disabled", true);
      this.giShopifyApi.getCart().then((cart) => {
        // console.log("got cart", {cart});
        // discount_code 作成
        return this.giServerApi.createCustomerDiscountCode({cart, usePoint});
      }).then(({customerDiscountCode, messages}) => {
        // console.log("issued customerDiscountCode", {customerDiscountCode, messages});
        this.updateViewByCustomerDiscountCode({customerDiscountCode, messages});
      }).finally(() => {
        button.removeAttribute("disabled");
      });
    });

    this.getCustomerAndUpdateView().then((customer) => {
      if(customer) {
        // loginしているならdiscount_codeも取得して描画
        this.getCustomerDiscountCodeAndUpdateView();
      }
    });
  }

  createElementDiscountCodeTag(prefix, discount_code) {
    const element = document.createElement("div");
    element.className = `${this._classGiPointifyContainerTag}`;

    let html = "";
    html += `<span class="gi-pointify-tag-discount-code-prefix">${prefix}</span>`;
    html += `<span class="gi-pointify-tag-discount-code">${discount_code}</span>`;
    html += `<button class="${this._classGiPointifyButtonTagClose}">x</button>`;
    element.innerHTML = html;
    element.querySelector(`button.${this._classGiPointifyButtonTagClose}`).addEventListener("click", (event) => {
      // 削除ボタン
      // console.log("onclick", "close");
      event.preventDefault();
      this.giShopifyApi.getCart().then((cart) => {
        // 0ポイントを指定して無効化
        return this.giServerApi.createCustomerDiscountCode({cart, usePoint: 0});
      }).then(({customerDiscountCode, messages}) => {
        // console.log("issued customerDiscountCode", {customerDiscountCode, messages});
        this.updateViewByCustomerDiscountCode({customerDiscountCode, messages});
      });
    });
    return element;
  }

  initContainerExtendCartForm() {
    // cart-formにディスカウントコードを入力するhidden-inputを作成する
    const inputQuery = this.giPointifyObject.store_dom_params_hash.selector_view_cart_form;
    if (!inputQuery) {
      // cartform設定なし
      this.console_error("initContainerExtendCartForm", "cart-formに対する設定がありません。pointifyの設定を見直してください。", inputQuery);
      return false
    }
    const targetElements = document.querySelectorAll(inputQuery);
    if (!targetElements) {
      // 対象のformなし
      this.console_log("initContainerExtendCartForm", "cart-formが存在しません", inputQuery);
      return false;
    }

    let elements = document.querySelectorAll(`#${this._classGiPointifyContainerExtendCartForm}`);
    if(elements.length != 0) {
      // 既に作成されている場合
      this.console_log("initContainerExtendCartForm", "alread init elements", elements);
      return false;
    }
    const element = document.createElement("div");
    element.className = this._classGiPointifyContainerExtendCartForm;
    if (!this.debug_dom_params || this.debug_dom_params !== "show_discount_code_input") {
      // TODO debug時は表示させている
      element.setAttribute("hidden", true);
    } else {
      // console.log("initContainerExtendCartForm", {debug_dom_params: this.debug_dom_params});
      element.innerHTML = "extend-container";
    }
    targetElements.forEach((targetElement, i) => {
      targetElement.appendChild(element);
    });
  }
  getContainersExtendCartForm() {
    return document.querySelectorAll(`.${this._classGiPointifyContainerExtendCartForm}`);
  }
  createInputDiscountCode(discountCode) {
    this.console_log("createInputDiscountCode", discountCode);
    this.deleteInputDiscountCode(); // 既存のinputをまず削除
    const containerElements = this.getContainersExtendCartForm();
    const element = document.createElement("div");
    element.className = `${this._classGiPointifyContainerInputHiddenDiscountCode}`;
    let html = "";
    html += `<input class="${this._classGiPointifyInputHiddenDiscountCode}" type="text" name="discount" `;
    html += `  value="${discountCode}" />`;
    element.innerHTML = html;
    containerElements.forEach((containerElement, i) => {
      containerElement.appendChild(element);
    });
  }
  deleteInputDiscountCode() {
    this.console_log("deleteInputDiscountCode");
    const containerElements = this.getContainersExtendCartForm()
    containerElements.forEach((containerElement, i) => {
      const elements = containerElement.querySelectorAll(`.${this._classGiPointifyInputHiddenDiscountCode}`);
      elements.forEach((element, i) => {
        element.remove();
      });
    });
  }

  createGivenPointTextNode() {
    const product = this.giShopifyObject.product;
    const productVariantId = this.getCurrentProductVariantId()
    // this.console_log("createGivenPointTextNode", {product, productVariantId})
    if (!product || !productVariantId) {
      return new Promise((resolve) => {resolve(null)});
    }

    const productVariant = product.variants.find(variant => variant.id == productVariantId);
    const price = productVariant.price;
    const compareAtPrice = productVariant.compare_at_price;
    const currencyRate = this.giShopifyObject.currencyRate;
    // this.console_log("createGivenPointTextNode", {productVariant, price, compareAtPrice, currencyRate})

    const promise = new Promise((resolve) => {
      resolve(this.getCustomer());
    }).then((customer) => {
      if (!customer) {
        // 未ログイン
        return null
      } else if(compareAtPrice !== null
        && compareAtPrice !== 0
        && this.giPointifyObject.ratio_currency_to_point_of_discounted_variant !== null
        && this.giPointifyObject.ratio_currency_to_point_of_discounted_variant !== "") {
        // セール品 かつ セール品に対するポイント付与率指定ありの場合
        return this.giPointifyObject.ratio_currency_to_point_of_discounted_variant;
      } else if(!customer.rank_ratio_currency_to_point) {
        // 会員ランクによるratioなしの場合はshopに指定されたratioを使用する
        return this.giPointifyObject.ratio_currency_to_point;
      } else {
        // 会員ランクによるratioありの場合
        return customer.rank_ratio_currency_to_point;
      }
    }).then((ratioCurrencyToPoint) => {
      if(!ratioCurrencyToPoint) {
        return null;
      } else {
        const money = price * currencyRate;
        const point = money * ratioCurrencyToPoint;
        const rounded_point = Math.round(point);
        return rounded_point;
        // return document.createTextNode(`${rounded_point} ポイント還元`);
      }
    })
    return promise;
  }

  initContainerViewProductVariantPoint() {
    // ProductVariant選択時に付与ポイントを表示させる
    const product = this.giShopifyObject.product;
    const selectorViewProductPointContainer = this.giPointifyObject.store_dom_params_hash.selector_view_product_point_container;
    const positionViewProductPointContainer = this.giPointifyObject.store_dom_params_hash.position_view_product_point_container;
    if (!product || !selectorViewProductPointContainer) {
      // 商品ページではない or 商品ページへの設置なし
      return false;
    }
    const targetElement = document.querySelector(selectorViewProductPointContainer);
    if (!targetElement) {
      // 対象のelementなし
      this.console_error("not found targetElement(product-variant-point injection)", selectorViewProductPointContainer);
      return false;
    }



    let createdDiv = document.createElement("div");
    createdDiv.className = `${this._classGiPointifyCanGetPoints}`;
    // TODO positionViewProductPointContainerによる挿入位置
    targetElement.after(createdDiv);
    let currentTextNode = document.createTextNode(``); // dummyを作成しておく
    createdDiv.appendChild(currentTextNode);

    this.createGivenPointTextNode().then((rounded_point) => {
      if (rounded_point) {
        let newTextNode = document.createTextNode(`${rounded_point} ポイント還元`);
        createdDiv.replaceChild(newTextNode, currentTextNode);
        currentTextNode = newTextNode;
        this.getPointInfoAndUpdateView(rounded_point);
      }
    });

    this.setEventListenerOnChangeProductVariantId((event) => {
      // variantが切り替わった場合にポイントを再計算
      this.createGivenPointTextNode().then((rounded_point) => {
        if (rounded_point) {
          let newTextNode = document.createTextNode(`${rounded_point} ポイント還元`);
          createdDiv.replaceChild(newTextNode, currentTextNode);
          currentTextNode = newTextNode;
          this.getPointInfoAndUpdateView(rounded_point);
        }
      });
    });
  }

  initContainerViewExternalOrderSummaries() {
    // 外部注文履歴表示
    const selectorViewExternalOrderSummariesContainer = this.giPointifyObject.store_dom_params_hash.selector_view_external_order_summaries_container;
    const positionViewExternalOrderSummariesContainer = this.giPointifyObject.store_dom_params_hash.position_view_external_order_summaries_container;
    if (!selectorViewExternalOrderSummariesContainer) {
      // account-infoに表示なし
      this.console_log("initContainerViewExternalOrderSummaries", "not setting selectorViewExternalOrderSummariesContainer");
      return false
    }
    const targetElement = document.querySelector(selectorViewExternalOrderSummariesContainer);
    if (!targetElement) {
      // 対象のelementなし
      this.console_error("initContainerViewExternalOrderSummaries", "not found targetElement(external-orders injection)", selectorViewExternalOrderSummariesContainer);
      return false;
    }

    let element = document.querySelector(`#${this._idGiPointifyExternalOrderSummariesContainer}`);

    if(element) {
      // 既に作成されている場合
      this.console_log("initContainerViewExternalOrderSummaries", "alread init element", element);
      return false;
    }

    this.console_log("initContainerViewExternalOrderSummaries", "create div", element);
    // まだ未設置の場合、作成して設置
    element = document.createElement("div");
    element.id = this._idGiPointifyExternalOrderSummariesContainer;
    element.className = this._classGiPointifyContainerDisplayOnGotExternalOrderSummaries;
    element.setAttribute("hidden", true);

    let html = ""
    html += `<div class="${this._classGiPointifyExternalOrderSummariesContainer}"></div>`;
    element.innerHTML = html;

    if (positionViewExternalOrderSummariesContainer === "before") {
      targetElement.before(element);
    } else {
      targetElement.after(element);
    }
    this.getExternalOrderSummariesAndUpdateView();
  }

  createExternalOrdersTable(externalOrderSummaries) {
    let html = "";
    // html += `<p class="uppercase strong">ご注文履歴（店舗/その他）</p>`
    html += `<div class="table-wrap"><table class="full table--responsive gi-pointify-external-order-summaries-table">`;
    html += ` <thead><tr>`;
    html += `  <th>注文番号</th>`;
    html += `  <th>注文日</th>`;
    html += `  <th>店舗</th>`;
    html += `  <th>合計（税込）</th>`;
    html += ` </tr></thead>`;
    html += ` <tbody>`;
    const currencyNumberFormat = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' })
    externalOrderSummaries.forEach((externalOrderSummary, i) => {
      html += `<tr class="gi-pointify-external-order-summaries-summary-row">`;
      html += ` <td class="gi-pointify-external-order-summaries-summary-cell" data-label="ご注文">${externalOrderSummary.display_order_code}</td>`;
      html += ` <td class="gi-pointify-external-order-summaries-summary-cell" data-label="日付">${externalOrderSummary.display_orderd_by}</td>`;
      html += ` <td class="gi-pointify-external-order-summaries-summary-cell" data-label="店舗">${externalOrderSummary.display_store_name}</td>`;
      html += ` <td class="gi-pointify-external-order-summaries-summary-cell" data-label="合計" style="text-align: right;">${currencyNumberFormat.format(externalOrderSummary.display_subtotal_price)}</td>`;
      html += `</tr>`;
      if (externalOrderSummary.external_orders && 0 < externalOrderSummary.external_orders.length) {
        html += `<tr class="gi-pointify-external-order-summaries-item-row">`;
        html += ` <td class="gi-pointify-external-order-summaries-item-cell" colspan="1" style="vertical-align: top; text-align: right;"></td>`;
        html += ` <td class="gi-pointify-external-order-summaries-item-cell" colspan="3">`;
        externalOrderSummary.external_orders.forEach((externalOrder, i) => {
          html += `  <div class="gi-pointify-subtable-flex-columns" style="margin-left: 14px; margin-bottom: 4px">`;
          html += `   <div class="gi-pointify-subtable-flex">`;
          html += `    <div>${externalOrder.display_product_name}</div>`;
          html += `   </div>`;
          html += `   <div class="gi-pointify-subtable-flex">`;
          if (externalOrder.display_sku) {
            html += `    <div>（品番：${externalOrder.display_sku}）</div>`;
          }
          html += `    <div style="margin-left: auto;">`;
          if (externalOrder.display_quantity) {
            html += `     <span>${externalOrder.display_quantity}点、</span>`;
          }
          html += `     <span>${currencyNumberFormat.format(externalOrder.display_subtotal_price)}</span>`;
          html += `    </div>`;
          html += `   </div>`;
          html += `  </div>`;
        });
        html += ` </td>`;
        html += `</tr>`;
      }
    });
    html += ` </tbody>`;
    html += `</table></div>`;
    return html;
  }

  createPointInfosHtml(pointInfos) {
    let html = "";
    if(pointInfos['is_increase']){
      let point_rate = pointInfos['rate']/100
      let title = pointInfos['display_title'] == '' ? `ポイント${point_rate}倍中！` : pointInfos['display_title'];
      html += `<div style="font-weight:bold;color:#ff0000;">${title}</div>`;
    }
    return html;
  }
  createPointInfosHtmlForCart(pointInfos) {
    let html = "";
    if(pointInfos['is_increase']){
      let point_rate = pointInfos['rate']/100
      let title = pointInfos['display_title'] == '' ? `ポイント${point_rate}倍中！` : pointInfos['display_title'];
      html += `<div style="font-weight:bold;color:#ff0000;">${title}</div>`;
    }
    return html;
  }

} // class GiPointifyView

class GiServerApi {
  constructor({giShopifyObject}) {
    this.giShopifyObject = giShopifyObject
    this.shopDomain = this.giShopifyObject.shop.domain;
    this.customerId = this.giShopifyObject.customer.id;
    this.customerHash = this.giShopifyObject.customer.hash;
    this.apiBase = "apps/pointify";
    this.apiVersion = "api/v1";

  }

  createUrl(api_path) {
    const url = `https://${this.shopDomain}/${this.apiBase}/${this.apiVersion}/${api_path}`;
    return url;
  }

  getCustomerDiscountCode({cart}) {
    const api_path = `discount_codes/current`;
    const url = this.createUrl(api_path)
    const data = {
      cart_token: cart.token,
    };
    return this.wrapFetch({url, data, func: ({data, messages}) => {
      return {customerDiscountCode: data.customer_discount_code, messages};
    }});
  }

  createCustomerDiscountCode({cart, usePoint}) {
    const api_path = `discount_codes/`;
    const url = this.createUrl(api_path)
    const data = {
      cart: cart,
      use_point: usePoint,
    };
    return this.wrapFetch({url, data, method: "POST", func: ({data, messages}) => {
      return {customerDiscountCode: data.customer_discount_code, messages};
    }});
  }

  getCustomer({customerId}) {
    const api_path = `customers/${customerId}`;
    const url = this.createUrl(api_path)
    return this.wrapFetch({url, func: ({data, messages}) => {return data.customer}})
  }

  getExternalOrderSummaries() {
    const api_path = `external_order_summaries`;
    const url = this.createUrl(api_path)
    return this.wrapFetch({url, func: ({data, messages}) => {return data.external_order_summaries}})
  }

  getPointInfo({productId,price,quantity,fetchType}) {
    const api_path = `point_infos`;
    const url = this.createUrl(api_path)
    const data = {
      product_id: productId,
      price: price,
      quantity: quantity,
      fetch_type: fetchType,
    };
    return this.wrapFetch({url, data, func: ({data, messages}) => {return data.point_infos}})
  }

  wrapFetch({url, data={}, method="GET", func=null}) {
    // console.log({url, data});
    let _url = url;
    const option = {
      method: method,
      mode: 'cors',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    };

    const _data = {
      customer_id: this.customerId,
      customer_hash: this.customerHash,
      ...data
    };
    if (method === "GET") {
      const queryString = new URLSearchParams(_data);
      _url = `${url}?${queryString}`;
    } else {
      option.body = JSON.stringify(_data);
    }

    const promise = fetch(_url, option).then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('api error');
      }
    }).then((json) => {
      return {data: json.data, messages: json.messages};
    }).then(({data, messages}) => {
      if(func) {
        return func({data, messages});
      } else {
        return {data, messages};
      }
    }).catch(error => {
      console.error({error});
      return null;
    })
    return promise;
  }
}

class GiShopifyApi {
  getCart() {
    const url = `/cart.js`;
    return this.wrapFetch({url})
  }
  wrapFetch({url, data=null}) {
    // console.log({url, data});
    let _url = url;
    if (data !== null) {
      const queryString = new URLSearchParams(data);
      _url = `${url}?${queryString}`;
    }
    const promise = fetch(_url, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('shopify api error');
      }
    }).catch(error => {
      console.error({error});
      return null;
    })
    return promise;
  }
}